//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from '@/api/index'
import finished from '@/assets/images/课程_已完成.png'
import continueAble from '@/assets/images/课程_暂停.png'
import disAble from '@/assets/images/课程_不可播放.png'
import playAble from '@/assets/images/课程_播放.png'
export default {
  data () {
    return {
      lessonList: [],
      FINISHED: '#2766ff',
      CONTINUE: 'blue'
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    initPage () {
      this.courseid = this.$route.query.courseid
      this.getLessonList()
    },
    getLessonList () {
      api.getLessonList({
        params: {
          courseid: this.courseid
        }
      }).then(resp => {
        this.lessonList = resp.result
      })
    },
    goBack () {
      this.$router.push({
        path: '/course/lesson',
        query: {
          courseid: this.$route.query.courseid,
          lessonid: this.$route.query.lessonid
        }
      })
    },
    // 播放
    play (citem) {
      console.log(citem)
      if (citem.stage === 'FREE' || citem.stage === 'FINISHED' || citem.stage === 'CONTINUE' || citem.stage === 'EXAMINATION') {
        this.$router.push({
          path: '/course/lesson',
          query: {
            lessonid: citem.lessonid,
            courseid: this.courseid
          }
        })
      } else if (citem.stage === 'DISABLED') {
        return null
      }
    }
  },
  filters: {
    getIcon: function (value) {
      if (value === 'FREE') {
        return playAble
      } else if (value === 'FINISHED') {
        return finished
      } else if (value === 'CONTINUE' || value === 'EXAMINATION') {
        return continueAble
      } else if (value === 'DISABLED') {
        return disAble
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/index/course/menuPage.vue